import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/images/icon_add.png'


const _hoisted_1 = { class: "user-select" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "选择员工", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "user-select-modal__bd" }
const _hoisted_9 = { class: "user-select__left" }
const _hoisted_10 = { class: "user-select__left__hd" }
const _hoisted_11 = { class: "user-select__left__bd" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { style: {"margin-left":"6px"} }
const _hoisted_14 = { class: "user-select__right" }
const _hoisted_15 = { class: "user-select__right__hd" }
const _hoisted_16 = { class: "text-grey" }
const _hoisted_17 = { class: "user-select__right__bd" }
const _hoisted_18 = { class: "selected-user__icon" }
const _hoisted_19 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_a_tag = _resolveComponent("a-tag")
  const _component_user_search_select = _resolveComponent("user-search-select")
  const _component_user_outlined = _resolveComponent("user-outlined")
  const _component_fork_outlined = _resolveComponent("fork-outlined")
  const _component_vxe_column = _resolveComponent("vxe-column")
  const _component_vxe_table = _resolveComponent("vxe-table")
  const _component_ant_icon = _resolveComponent("ant-icon")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["user-content", {'is-error':_ctx.isError,'disabled':_ctx.disabled}])
        }, [
          _createElementVNode("div", {
            class: "user-list",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
          }, [
            (!_ctx.tempUsers.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "请选择"))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tempUsers, (user) => {
                  return (_openBlock(), _createBlock(_component_a_tag, {
                    disabled: _ctx.disabled,
                    key: user.id,
                    closable: !_ctx.disabled,
                    color: "blue",
                    onClose: _withModifiers($event => (_ctx.deleteSelectedUser(user.id)), ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      (user.name.length<10)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(user.name), 1))
                        : (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 1,
                            title: user.name,
                            class: "append-to-body"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(user.name.slice(0,9)+'...'), 1)
                            ]),
                            _: 2
                          }, 1032, ["title"]))
                    ]),
                    _: 2
                  }, 1032, ["disabled", "closable", "onClose"]))
                }), 128))
          ]),
          (_ctx.tempUsers.length < _ctx.maxCount)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "add-icon",
                type: "link",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
              }, _hoisted_5))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = $event => ((_ctx.visible) = $event)),
      centered: true,
      keyboard: false,
      "mask-closable": false,
      class: "user-select-modal user-mod",
      width: "520px",
      zIndex: 1002,
      onCancel: _ctx.cancelFn,
      onOk: _ctx.ok
    }, {
      title: _withCtx(() => [
        _hoisted_6,
        (_ctx.maxCount && _ctx.maxCount !== Infinity)
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, "本次操作最多可选 " + _toDisplayString(_ctx.maxCount) + " 个员工", 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_user_search_select, {
                value: _ctx.userSearchId,
                "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.userSearchId) = $event)),
                class: "w100",
                placeholder: "输入员工姓名关键字",
                "activated-status": _ctx.activatedStatus,
                "on-job": _ctx.onJob,
                status: _ctx.status,
                userState: _ctx.userStatus,
                onSelect: _ctx.onUserSearchSelect
              }, null, 8, ["value", "activated-status", "on-job", "status", "userState", "onSelect"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.visible)
                ? (_openBlock(), _createBlock(_component_vxe_table, {
                    key: 0,
                    "show-header": false,
                    border: "none",
                    ref: "xTree",
                    "row-config": {keyField: 'id'},
                    "column-config": {resizable: true},
                    "tree-config": {transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasEmployee', loadMethod: _ctx.loadDepartment},
                    data: _ctx.treeData
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_vxe_column, {
                        field: "name",
                        title: "公司员工",
                        width: "260",
                        "tree-node": true
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("span", {
                            class: _normalizeClass(row.isLeaf&&!row.isDepartment?'is-leaf':''),
                            onClick: $event => (_ctx.clickRow(row))
                          }, [
                            (row.isLeaf)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (!row.isDepartment)
                                    ? (_openBlock(), _createBlock(_component_user_outlined, { key: 0 }))
                                    : (_openBlock(), _createBlock(_component_fork_outlined, { key: 1 }))
                                ], 64))
                              : (_openBlock(), _createBlock(_component_fork_outlined, { key: 1 })),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(row.name), 1)
                          ], 10, _hoisted_12)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["tree-config", "data"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, "已选择的成员 （ " + _toDisplayString(_ctx.tempUsers.length) + " 个）", 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempUsers, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "selected-user"
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_ant_icon, { type: "UserOutlined" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.name), 1),
                  _createElementVNode("div", {
                    class: "selected-user__delete",
                    onClick: $event => (_ctx.deleteTempUser(item.id))
                  }, [
                    _createVNode(_component_ant_icon, { type: "CloseCircleOutlined" })
                  ], 8, _hoisted_19)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onOk"])
  ]))
}